// export const getAccessToken = () => localStorage.getItem('access_token');
// export const getRefreshToken = () => localStorage.getItem('refresh_token');
import objeler from '../objeler';

export const getAccessToken = () => {
    try {
        // console.log('getAccessToken',objeler.User.Token.AccessToken);
        return objeler.User.Token.AccessToken;
    } catch (e) {
        return null;
    }
};
export const getRefreshToken = () => {
    // console.log("FFFF", objeler.User)
    try {
        return objeler.User.Token.RefreshToken;
    } catch (e) {
        return null;
    }
};
export const setTokens = ({accessToken, refreshToken}) => {
    // localStorage.setItem('access_token', accessToken);
    //
    // localStorage.setItem('refresh_token', refreshToken);

    objeler.User.Token.AccessToken = accessToken
    objeler.User.Token.RefreshToken = refreshToken

    // console.log('YENI TOKEN')
    // console.log(objeler.User.Token.AccessToken)
    // console.log(objeler.User.Token.RefreshToken)
};

export const clearTokens = () => {
    // localStorage.removeItem('access_token');
    // localStorage.removeItem('refresh_token');
};
